import controller from './vd-tooltip.controller'
import template from './vd-tooltip.html'

const TooltipComponent = {
  controller,
  template,
  transclude: true,
}

export default TooltipComponent
